const STORAGE_KEY = "phoneboard.inbound-messages.device-filter";
export const INBOUND_DEVICE_FILTER_EVENT = "phoneboard:inbound-device-filter";

export function readInboundDeviceFilter(): string {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(STORAGE_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}

/**
 * 선택 폰은 이 브라우저에서만 기억한다. 같은 탭에 수신 내역 화면이 이미 열려 있을 수 있으므로
 * localStorage와 함께 이벤트도 보내 즉시 화면을 맞춘다.
 */
export function rememberInboundDeviceFilter(deviceId: string): void {
  if (typeof window === "undefined") return;
  try {
    if (deviceId) window.localStorage.setItem(STORAGE_KEY, deviceId);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // 저장소를 막은 브라우저에서도 현재 화면 선택은 이벤트로 계속 동작한다.
  }
  window.dispatchEvent(
    new CustomEvent<string>(INBOUND_DEVICE_FILTER_EVENT, { detail: deviceId }),
  );
}
